import {LAYER_LABELS_ID, LAYER_LABELS_SOURCE} from '../mapbox-constants/mapbox_constants';

const layerLabels = (mapConfig) => {
  return {
    id: LAYER_LABELS_ID,
    source: LAYER_LABELS_SOURCE,
    type: 'raster',
    paint: {
      'raster-opacity': 1,
      'raster-fade-duration': 1,
    },
    maxzoom: mapConfig.ZOOM_MAX_SECTIONS,
    minzoom: mapConfig.ZOOM_MIN_SECTIONS,
  };
};

export default {layerLabels};
